<script>
  import { onMount } from "svelte";
  import { keyFilms, genreFilms, serveurFilm } from "../conf.js";
  import { link } from "svelte-spa-router";
  import Overlay from "../ihm/ToolsOverlay.svelte";

  let lesfilms = undefined;
  let titreFilm = "";
  let anneeFilm = 0;
  let genreFilmsSelected = 0;
  let totalResult = 0;
  let totalPages = 0;
  let currentPage = 1;
  let memoUrl = "";
  let memoArg = "";
  let tabNavPage = [];
  const tabKeys = [];
  const tabValues = [];

  /**
   *https://api.themoviedb.org/3/search/movie?api_key={api_key}&query=Jack+Reacher
   */
  const chercherFilms = async (url = "", arg = "") => {
    let urlStr = "";

    if (url != memoUrl || arg != memoArg) {
      memoUrl = url;
      memoArg = arg;
      currentPage = 1;
      titreFilm = "";
    }

    if (url == "") {
      urlStr = serveurFilm + "movie/550";
    } else {
      urlStr = url;
    }

    urlStr =
      serveurFilm +
      urlStr +
      "?language=fr-FR&api_key=" +
      keyFilms +
      "&page=" +
      currentPage +
      "&" +
      arg;

    console.log(urlStr);

    const response = await fetch(urlStr);

    if (response.ok) {
      const result = await response.json();
      totalPages = result.total_pages;
      totalResult = result.total_results;
      //currentPage = result.page;

      console.log(totalPages);

      return result.results;
    } else {
      throw new (error(text))();
    }
  };

  /**
   *
   */
  const chercherPopular = async () => {
    const url = "movie/popular";
    lesfilms = await chercherFilms(url, "");
    tabNavPage = createTabPages();
  };

  /**
   *
   */
  const chercherTopRate = () => {
    const url = "movie/top_rated";
    lesfilms = chercherFilms(url, "");
    tabNavPage = createTabPages();
  };

  /**
   *
   */
  const chercherByTitle = () => {
    let args = "";
    if (titreFilm != 0) {
      args = args + "query=" + titreFilm;
      lesfilms = chercherFilms("search/movie", args);
      tabNavPage = createTabPages();
      titreFilm = "";
    }
  };

  /**
   *
   */
  const chercherByYear = () => {
    let args = "";
    if (anneeFilm != 0) {
      args = args + "primary_release_year=" + anneeFilm;
      lesfilms = chercherFilms("discover/movie", args);
      tabNavPage = createTabPages();
      anneeFilm = 0;
    }
  };

  /**
   *
   */
  const chercherFilmsSimilaire = (id) => {
    if (id != 0) {
      const url = "movie/" + id + "/similar";
      lesfilms = chercherFilms(url);
    }
  };

  /**
   *
   * @param id
   */
  const chercherByGenre = async () => {
    console.log("Genre = " + genreFilmsSelected);

    if (genreFilmsSelected != 0) {
      lesfilms = await chercherFilms(
        "discover/movie",
        "with_genres=" + genreFilmsSelected + "&sort_by=popularity.desc"
      );
      tabNavPage = createTabPages();
    }
  };

  // ============= . PAGINATION ===============
  /**
   *
   */
  const createTabPages = () => {
    let tabTemp = [];
    let borneDepart = 1;

    if (currentPage > 4) {
      borneDepart = currentPage - 3;
      tabTemp.push("...");
    }

    for (let i = borneDepart; i < borneDepart + 6; i++) {
      tabTemp.push(i);
    }

    if (borneDepart + 6 < totalPages) {
      tabTemp.push("...");
    }
    return tabTemp;
  };

  /***
   *
   */
  const suivant = () => {
    //console.log("suiv   nt");
    ++currentPage;
    lesfilms = chercherFilms(memoUrl, memoArg);
    tabNavPage = createTabPages();
  };

  /**
   *
   */
  const precedent = () => {
    //console.log("precedent");
    --currentPage;
    lesfilms = chercherFilms(memoUrl, memoArg);
    tabNavPage = createTabPages();
  };

  /**
   *
   */
  const newPage = (page) => {
    console.log("page");
    currentPage = page;
    lesfilms = chercherFilms(memoUrl, memoArg);
    tabNavPage = createTabPages();
  };

  //=============================

  /**
   * REmet le JSON des genres dans un tableau pour le popup
   */
  const convertiGenreEnTableau = () => {
    $genreFilms.forEach((element) => {
      tabKeys.push(element.id);
      tabValues.push(element.name);
    });
  };

  onMount(async () => {
    convertiGenreEnTableau();
  });
</script>

{#await lesfilms}
  <Overlay />
{:then lesfilms}
  <div class="container-fluid">
    <!------   PAGINATION ------>
    {#if totalPages != 0}
      <nav aria-label="Page navigation example">
        <ul class="pagination pagination-sm">
          <li class="page-item">
            <a class="page-link" on:click|preventDefault={precedent} href={null}
              >Prévious</a
            >
          </li>
          {#each tabNavPage as i}
            <li class="page-item">
              <a
                class="page-link {i == currentPage ? 'active' : ''}"
                on:click|preventDefault={newPage(i)}
                href={null}>{i}</a
              >
            </li>
          {/each}
          <li class="page-item">
            <a class="page-link" on:click|preventDefault={suivant} href={null}
              >Next</a
            >
          </li>
        </ul>
      </nav>
    {/if}

    pages : {currentPage} - {totalResult}

    <div class="row">
      <div class="col-4">
        <h6>Liste des films</h6>
      </div>
      <div class="col-4">
        <select
          bind:value={genreFilmsSelected}
          class="form-select"
          aria-label="Default select "
          on:change={chercherByGenre}
        >
          {#each $genreFilms as item}
            <option value={item.id}>{item.name} - ({item.id})</option>
          {/each}
        </select>
      </div>
    </div>

    <div class="row">
      <!--------  Le formulaire ------------------->
      <form class="d-flex" role="search">
        <input
          on:change={chercherByTitle}
          bind:value={titreFilm}
          class="form-control me-2"
          type="search"
          placeholder="titre du film"
          aria-label="Search"
          size="25px"
        />
        <input
          on:change={chercherByYear}
          bind:value={anneeFilm}
          class="form-control ms-2"
          type="search"
          placeholder="Annee"
          aria-label="Search"
          size="20px"
        />
        <button on:click|preventDefault={chercherByTitle} class="btn btn-info"
          >?</button
        >
      </form>
    </div>
    <!-------- les boutons ---------->
    <div class="row">
      <button
        on:click={chercherPopular}
        id="bt1"
        type="button"
        class="btn btn-primary btn-group-sm">Populaires</button
      >
      <button
        on:click={chercherTopRate}
        id="bt2"
        type="button"
        class="btn btn-primary btn-group-sm">Mieux notés</button
      >
    </div>
    {#if lesfilms != undefined}
      {#each lesfilms as film}
        <div class="card col-12">
          <div class="card col-4">
            <img
              src="https://image.tmdb.org/t/p/w92/{film.poster_path}"
              alt="..."
              width="70%"
              height="70%"
            />
          </div>
          <div class="card-body">
            <h5 class="card-title">{film.original_title}</h5>
            <p class="card-text">{film.overview}</p>
            <p class="card-text">
              <strong>Année : {film.release_date}</strong>
            </p>
            <p class="card-text">
              <strong>Genre(s):</strong>
              {#each film.genre_ids as genre}
                {tabValues[tabKeys.indexOf(genre)]},
              {/each}
            </p>
            <p class="card-text vote">
              vote : {film.vote_count} - {film.vote_average}
            </p>

            <a href="/film/{film.id}" use:link class="btn btn-primary">Détail</a
            >
          </div>
        </div>
      {/each}
    {/if}

    <!------   PAGINATION ------>
    {#if totalPages != 0}
      <nav aria-label="Page navigation example">
        <ul class="pagination pagination-sm">
          <li class="page-item">
            <a class="page-link" on:click|preventDefault={precedent} href={null}
              >Prévious</a
            >
          </li>
          {#each tabNavPage as i}
            <li class="page-item">
              <a
                class="page-link {i == currentPage ? 'active' : ''}"
                on:click|preventDefault={newPage(i)}
                href={null}>{i}</a
              >
            </li>
          {/each}
          <li class="page-item">
            <a class="page-link" on:click|preventDefault={suivant} href={null}
              >Next</a
            >
          </li>
        </ul>
      </nav>
    {/if}
  </div>
{/await}

<style>
  .vote {
    font-weight: bold;
    color: red;
  }
</style>
